var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2334 3.18668H12.0868V2.01335C12.0868 1.64668 11.7868 1.34668 11.4201 1.34668C11.0534 1.34668 10.7534 1.64668 10.7534 2.01335V3.18668H5.24675V2.01335C5.24675 1.64668 4.94675 1.34668 4.58008 1.34668C4.21342 1.34668 3.91342 1.64668 3.91342 2.01335V3.18668H2.76675C2.20675 3.18668 1.75342 3.64001 1.75342 4.20001V13.32C1.75342 13.88 2.26008 14.3333 2.88675 14.3333H13.1067C13.7334 14.3333 14.2401 13.88 14.2401 13.32V4.20001C14.2401 3.64001 13.7867 3.18668 13.2268 3.18668H13.2334ZM5.38008 12.1267H3.78008V10.5267H5.38008V12.1267ZM5.38008 9.07335H3.78008V7.47335H5.38008V9.07335ZM8.80008 12.1267H7.20008V10.5267H8.80008V12.1267ZM8.80008 9.07335H7.20008V7.47335H8.80008V9.07335ZM12.2201 12.1267H10.6201V10.5267H12.2201V12.1267ZM12.2201 9.07335H10.6201V7.47335H12.2201V9.07335Z",
    fill: "#769DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.61a757f52370e50908774dd7b99a3aad.svg";
export { ForwardRef as ReactComponent };